import React, { useEffect, useMemo, useRef, useState } from "react";
// 移除了 useMap，因为缩放逻辑将由父组件提供
// import { useMap } from '@vis.gl/react-google-maps'; // 不再需要直接操作 map 实例
import { Tooltip } from "antd";
import { getGradientColor, rgbToString } from "@/page/WeevilTrak/weevilTrakCommonFunc";
interface IZoomControlsProps {
  onZoomIn: () => void; // 放大回调
  onZoomOut: () => void; // 缩小回调
  handleMapCenterForCurrent?: (lat: number, lng: number) => void; // 用于设置地图中心点的回调函数
  // 可以添加 maxZoom 和 minZoom 来禁用按钮
  currentZoom?: number;
  minZoom?: number;
  maxZoom?: number;

    // Actual pixel height of the parent map container.
    // Used to size the gradient bar dynamically.
    mapContentHeight?: number;
}

const ZoomControls: React.FC<IZoomControlsProps> = ({
    onZoomIn,
    onZoomOut,
    currentZoom,
    minZoom,
    maxZoom,
    mapContentHeight
}) => {

    const canZoomIn = currentZoom === undefined || maxZoom === undefined || currentZoom < maxZoom;
    const canZoomOut = currentZoom === undefined || minZoom === undefined || currentZoom > minZoom;



    const gradientBarRef = useRef<HTMLDivElement | null>(null);

    const clampedGradientBarHeight = useMemo(() => {
        if (mapContentHeight === undefined || Number.isNaN(mapContentHeight)) return undefined;
        return Math.max(90, Math.min(700, mapContentHeight - 40 -60 -60));
    }, [mapContentHeight]);

    const generateGradientBar = () => {
        const bar = gradientBarRef.current;
        if (!bar) return;

        bar.innerHTML = "";

        // 创建左侧数字列
        const numbersColumn = document.createElement("div");
        numbersColumn.className = "numbers-column";

        // 创建右侧颜色块列
        const colorBlock = document.createElement("div");
        colorBlock.className = "color-block-column";

        // 关键数字标签
        const keyNumbers = [0, 10,20, 30, 40, 50, 60,70,80, 90];
        // 生成颜色条纹
        for (let i = 0; i <= 90; i++) {
            const { r, g, b } = getGradientColor(i);
            const stripe = document.createElement("div");
            stripe.className = "color-stripe";
            stripe.style.backgroundColor = rgbToString(r, g, b);
            stripe.title = `${i}: ${rgbToString(r, g, b)}`;
            colorBlock.appendChild(stripe);

            // 如果是关键数字，添加标签
            if (keyNumbers.includes(i)) {
                const label = document.createElement("div");
                label.className = "number-label";
                label.textContent = i?.toString();
                numbersColumn.appendChild(label);
            } else {
                // 添加空白占位
                const spacer = document.createElement("div");
                spacer.className = "number-label";
                numbersColumn.appendChild(spacer);
            }
        }

        bar.appendChild(numbersColumn);
        bar.appendChild(colorBlock);
    };

    useEffect(()=>{
        generateGradientBar();
    },[]);

    useEffect(() => {
        const bar = gradientBarRef.current;
        if (!bar) return;
        if (clampedGradientBarHeight === undefined) return;
        bar.style.height = `${clampedGradientBarHeight}px`;
    }, [clampedGradientBarHeight]);

    const [isZoomInTooltipVisible, setIsZoomInTooltipVisible] = useState(false);
    const [isZoomOutTooltipVisible, setIsZoomOutTooltipVisible] = useState(false);

    return (
        <div className="button-div" style={{
            position: "absolute",
            right: "20px",
            top: "5px",
            display: "flex",
            flexDirection: "column",
            zIndex: 9999,
            borderRadius: "4px",
            padding: "4px",
            gap:"10px",
            backgroundColor: "transparent"
        }}>
            <div className="weevilTrak-zoom">
                <span className="weevilTrak-legends-title">
                        No. of days left to enter each stage
                </span>
                <div className="weevilTrak-legends-container">
                    {/* 渐变条 */}
                    <div className="gradient-bar" id="gradientBar" ref={gradientBarRef}></div>

                </div>
                <Tooltip title="Zoom In" placement="left" visible={isZoomInTooltipVisible}>
                    <button
                        onClick={onZoomIn}
                        disabled={!canZoomIn} // 禁用条件
                        className="weevilTrak-zoom-in"
                        style={{
                            cursor: canZoomIn ? "pointer" : "not-allowed",
                        }}
                        onMouseEnter={() => setIsZoomInTooltipVisible(true)}
                        onMouseLeave={() => setIsZoomInTooltipVisible(false)}
                    >
        +
                    </button>
                </Tooltip>
                <Tooltip title="Zoom Out" placement="left" visible={isZoomOutTooltipVisible}>
                    <button
                        onClick={onZoomOut}
                        disabled={!canZoomOut} // 禁用条件
                        className="weevilTrak-zoom-out"
                        style={{
                            cursor: canZoomOut ? "pointer" : "not-allowed",
                        }}
                        onMouseEnter={() => setIsZoomOutTooltipVisible(true)}
                        onMouseLeave={() => setIsZoomOutTooltipVisible(false)}
                    >
        -
                    </button>
                </Tooltip>

            </div>
        </div>
    );
};

export default React.memo(ZoomControls);